import { Link } from "react-router-dom";
import Seo from "@/components/base/Seo";
import PageHero from "@/components/feature/PageHero";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { bounties, bountyLevels } from "@/mocks/bounties";

export default function Bounty() {
  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      name: "悬赏榜 - 爆料51",
      url: "https://kunkunedu.cn/bounty",
      description: "爆料51 悬赏榜，展示当前开放悬赏的线索、金额、等级与截止日期。",
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "首页", item: "https://kunkunedu.cn/" },
        { "@type": "ListItem", position: 2, name: "悬赏榜", item: "https://kunkunedu.cn/bounty" },
      ],
    },
    {
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: "爆料51 悬赏线索排行",
      itemListElement: bounties.map((item) => ({
        "@type": "ListItem",
        position: item.rank,
        name: item.title,
        url: "https://kunkunedu.cn/bounty",
      })),
    },
  ];

  return (
    <>
      <Seo
        title="悬赏榜 | 爆料51 悬赏线索排行与等级说明"
        description="查看爆料51 悬赏榜，了解当前开放悬赏的线索、悬赏金额、S/A/B 等级划分与截止日期，选择你熟悉的领域提供线索。"
        keywords="爆料51悬赏榜,悬赏线索,线索悬赏,征集令,提供线索"
        path="/bounty"
        jsonLd={jsonLd}
      />
      <PageHero
        eyebrow="悬赏榜"
        title="悬赏线索排行"
        description="悬赏金额依据线索的完整度、可核实性与社会影响综合评定。榜单实时更新，截止日期前均可提交相关信息。"
        crumbs={[{ label: "悬赏榜" }]}
      />

      <section className="w-full bg-background-50 py-12 md:py-16" aria-labelledby="bounty-levels">
        <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
          <Reveal>
            <SectionHeading
              id="bounty-levels"
              eyebrow="等级划分"
              title="三个等级，标准公开透明"
              description="我们不会用模糊的承诺吸引提交。每条线索的悬赏标准都可以在提交前对照查看。"
            />
          </Reveal>
          <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
            {bountyLevels.map((level, index) => (
              <Reveal key={level.level} delay={index * 80}>
                <div className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100 p-6">
                  <div className="flex items-center justify-between">
                    <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                      <i className={`${level.icon} text-2xl`} />
                    </span>
                    <span className="font-heading text-2xl font-bold text-foreground-950">{level.level}</span>
                  </div>
                  <p className="mt-5 font-heading text-base font-bold text-foreground-950">{level.range}</p>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{level.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full bg-background-100 py-12 md:py-16" aria-labelledby="bounty-list">
        <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
          <Reveal>
            <SectionHeading
              id="bounty-list"
              eyebrow="当前榜单"
              title="正在悬赏的线索"
              description="以下线索均开放悬赏，排名依据悬赏金额与参与热度。点击了解线索方向后，可前往提交入口提供信息。"
            />
          </Reveal>

          <ol className="mt-10 flex flex-col gap-3">
            {bounties.map((item, index) => (
              <Reveal key={item.rank} delay={index * 50}>
                <li className="flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-accent-300 md:flex-row md:items-center">
                  <span
                    className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-md font-heading text-lg font-bold ${
                      item.rank <= 3
                        ? "bg-primary-500 text-background-50"
                        : "bg-background-200 text-foreground-700"
                    }`}
                  >
                    {item.rank}
                  </span>

                  <div className="min-w-0 flex-1">
                    <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                      <Link to="/submit" title={`${item.title} - 提供线索`}>
                        {item.title}
                      </Link>
                    </h3>
                    <div className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-foreground-500">
                      <span className="rounded-md bg-secondary-100 px-2 py-0.5 text-secondary-800">
                        {item.category}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-calendar-line" />
                        截止 {item.deadline}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-group-line" />
                        {item.joiners} 人参与
                      </span>
                      <span className="rounded-md bg-accent-100 px-2 py-0.5 text-accent-800">{item.level}</span>
                    </div>
                  </div>

                  <div className="flex items-center justify-between gap-4 md:justify-end">
                    <div className="text-right">
                      <p className="font-heading text-xl font-bold text-accent-700">
                        ¥{item.amount.toLocaleString()}
                      </p>
                      <p className="text-xs text-foreground-500">悬赏金额</p>
                    </div>
                    <Link
                      to="/submit"
                      className="inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                    >
                      提供线索
                      <i className="ri-arrow-right-line" />
                    </Link>
                  </div>
                </li>
              </Reveal>
            ))}
          </ol>

          <div className="mt-10 flex flex-col items-center justify-between gap-4 rounded-lg border border-background-200 bg-background-50 p-6 md:flex-row md:p-8">
            <div>
              <h3 className="font-heading text-base font-bold text-foreground-950">没有找到你关注的悬赏方向？</h3>
              <p className="mt-1.5 text-sm text-foreground-600">
                你仍然可以主动提交线索，我们会根据线索价值评定悬赏等级并主动联系。
              </p>
            </div>
            <Link
              to="/submit"
              className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
            >
              <i className="ri-send-plane-line" />
              主动提交线索
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}